import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/AppLogin/Login/Login'
import Menu from '@/components/AppHorarios/Menu/Menu'
import auth from "@/router/auth";

const Dashboard = () => import('@/components/AppHorarios/Dashboard/Dashboard');
const Ausencias = () => import('@/components/AppHorarios/Ausencias/Ausencias');
const Ausencia = () => import('@/components/AppHorarios/Ausencias/Ausencia');
const Excepciones = () => import('@/components/AppHorarios/Excepciones/Excepciones');
const Excepcion = () => import('@/components/AppHorarios/Excepciones/Excepcion');
const Tiempos_Libres = () => import('@/components/AppHorarios/Tiempos_Libres/Tiempos_Libres');
const Tiempo_Libre = () => import('@/components/AppHorarios/Tiempos_Libres/Tiempo_Libre');
const Cambios = () => import('@/components/AppHorarios/Cambios/Cambios');
const Cambio = () => import('@/components/AppHorarios/Cambios/Cambio');
const Cambio_De_Horario_Page = () => import('@/components/AppHorarios/Cambios/Cambio_De_Horario_Page');
const Boton_Panico_Page = () => import('@/components/AppHorarios/Boton_Panico/BotonPanicoView');
const Boton_Panico_Detalle = () => import('@/components/AppHorarios/Boton_Panico/Boton_Panico_Detalle');
const Supervisores_List = () => import('@/components/AppHorarios/Supervisores/Lista');
const Supervisores_Detalle = () => import('@/components/AppHorarios/Supervisores/Detalle');
const Excepciones_Supervisores_Page = () => import('@/components/AppHorarios/ExcepcionesSupervisor/ExcepcionesSupervisorView');
const Excepciones_Supervisores_Detalle = () => import('@/components/AppHorarios/ExcepcionesSupervisor/Excepciones_Supervisor_Detalle');

Vue.use(Router)

function checkSession(to, from, next) {
    auth.check().then((res) => {
      if (res) {
        next();
      } else {
        this.$msal.signOut();
      }
    });
  }

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: '', name: 'Login', component: Login },
    {
      path: '/menu', name: 'Menu', component: Menu,
      children: [
        { 
          path: 'dashboard', 
          name: 'Dashboard', 
          component: Dashboard,
          beforeEnter: checkSession 
        },
        { 
          path: 'cambios', 
          name: 'Cambios', 
          component: Cambios,
          beforeEnter: checkSession
        },
        { 
          path: 'cambios/:idcambio', 
          name: 'Cambio', 
          component: Cambio,
          beforeEnter: checkSession
        },
        { 
          path: 'cambio_de_horario', 
          name: 'Cambio_De_Horario', 
          component: Cambio_De_Horario_Page,
          beforeEnter: checkSession
        },
        { 
          path: 'ausencias', 
          name: 'Ausencias', 
          component: Ausencias,
          beforeEnter: checkSession
        },
        { 
          path: 'ausencias/:idausencia', 
          name: 'Ausencia', 
          component: Ausencia,
          beforeEnter: checkSession
        },
        { 
          path: 'excepciones',
          name: 'Excepciones',
          component: Excepciones,
          beforeEnter: checkSession
        },
        { 
          path: 'excepciones/:idausencia',
          name: 'Excepcion',
          component: Excepcion,
          beforeEnter: checkSession
        },
        { 
          path: 'tiempo_libre',
          name: 'Tiempos_Libres',
          component: Tiempos_Libres,
          beforeEnter: checkSession
        },
        { 
          path: 'tiempo_libre/:idsolicitud',
          name: 'Tiempo_Libre',
          component: Tiempo_Libre,
          beforeEnter: checkSession
        },
        { 
          path: 'boton_panico',
          name: 'Boton_Panico',
          component: Boton_Panico_Page,
          beforeEnter: checkSession
        },
        { 
          path: 'boton_panico/:idoferta',
          name: 'Boton_Panico_Detalle',
          component: Boton_Panico_Detalle,
          beforeEnter: checkSession
        },
        { 
          path: 'supervisores',
          name: 'Supervisores',
          component:  Supervisores_List,
          beforeEnter: checkSession
        },
        { 
          path: 'supervisores/:id',
          name: 'Supervisores_Detail',
          component:  Supervisores_Detalle,
          beforeEnter: checkSession
        },
        { 
          path: 'excepcionesSupervisores',
          name: 'ExcepcionesSupervisores',
          component: Excepciones_Supervisores_Page,
          beforeEnter: checkSession
        },
        { 
          path: 'excepcionesSupervisores/:idoferta',
          name: 'Excepciones_Supervisores_Detalle',
          component: Excepciones_Supervisores_Detalle,
          beforeEnter: checkSession
        },
      ]
    },
  ],
})
